import React from "react";
import "./textbox.css"; // for styling

const TextBox = ({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  fullWidth = true,
  size = "medium",
  multiline = false,
  rows = 4,
  maincontStyle,
  mbtcls,
  maxLength,
  ...props
}) => {
  const today = new Date().toISOString().split("T")[0];
  return (
    <div
      className={`textbox-container ${fullWidth ? "full-width" : ""}`}
      style={maincontStyle}
    >
      {label && <label className="textbox-label fw-500">{label}</label>}
      {multiline ? (
        <textarea
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          className={`textbox ${size}`}
          {...props}
        />
      ) : (
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={maxLength ? maxLength : 100}
          className={`textbox ${size} ${mbtcls}`}
          {...(type === "date" ? { max: today } : {})}
          {...props}
        />
      )}
    </div>
  );
};

export default TextBox;
